<template>
  <v-card flat v-if="product" class="product-list-item pointer">
    <v-layout wrap>
      <!-- <v-flex class="item-img-wrap mr-4" shrink>
        <img :src="product.img">
        <div class="category-tag">{{tag}}</div>
      </v-flex> -->
      <v-flex class="item-content">
        <v-layout column justify-space-between fill-height>
          <v-layout justify-space-between shrink wrap>
            <v-flex xs12 md6>
              <h4>{{product.title}}</h4>
            </v-flex>
            <v-flex xs12 md6 class="text-md-right text-xs-left text1">
              <v-btn depressed color="primary" @click="handleBtn">
                支付{{product.price}}元阅读
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-text>
          <v-img
            src="/images/newImg/zhifu.jpg"
            contain
          ></v-img>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
           确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-card>
</template>

<script>
export default {
  props: {
    code: String
  },
  data() {
    return {
      dialog:false,
    };
  },
  computed: {
    product() {
      return this.$store.getters.getInfo(this.code);
    },
  },
  methods: {
    jump() {
      this.$router.push(`/product/detail/${this.code}`);
    },
    handleBtn(){
      this.dialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin sm-media {
  @media only screen and (max-width: map-get($breakpoints, sm)) {
    @content;
  }
}
.product-list-item {
  h4 {
    line-height: 50px;
    font-weight: 400;
  }
  padding:10px 30px;
  margin-bottom: 20px;
  .item-img-wrap {
    position: relative;
    height: 220px;
    .category-tag {
      position: absolute;
      top: 0;
      left: 0;
      padding: 7px 13px;
      border-bottom-right-radius: 19px;
      background-color: #292c31;
      opacity: 0.7;
      color: rgba(255, 255, 255, 0.7);
    }
  }
  .item-content {
    @include sm-media {
      margin-top: 1em;
    }
  }

  .features {
    margin-top: 20px;
    font-size: 15px;
    &-item {
      padding-right: 25px;
      span:before {
        content: "•";
        color: $primary-color;
        width: 5px;
        height: 5px;
        margin-right: 5px;
      }
    }
  }
}
</style>

<style lang="scss">
.product-list-item {
  .conditions-wrap {
    .primary-text {
      strong {
        font-size: 28px;
        font-weight: 400;
      }
    }
  }
}
</style>


